{
  "tabs": {
    "label": "Payment screens",
    "methods": "Ways to pay",
    "reconciliation": "Card terminal statements",
    "refunds": "Refunds"
  },
  "page": {
    "intro": "How customers can pay on the website and at the counter. Card terminal fees are worked out by the system from these settings.",
    "load_failed": "The payment settings could not be loaded.",
    "read_only": "You can read these settings. Only the owner can change them.",
    "add_title": "Not set up yet",
    "add": "Add {{name}}"
  },
  "state": {
    "on": "On",
    "off": "Off"
  },
  "channels": {
    "web": "Website",
    "web_desc": "Customers can choose it at checkout.",
    "pos": "Shop counter",
    "pos_desc": "Staff can take it at the register."
  },
  "save": "Save",
  "saved": "{{name}} saved.",
  "confirm_title": "Save {{name}}?",
  "confirm_consequence": "Customers and the register use the new settings at once. The change is kept in the history (who, when, before and after).",
  "pos_empty": "The counter needs at least one way to pay — switch another one on first.",
  "warnings": {
    "needs_review": "These are example values — check them against your real contract.",
    "provider_phase_2": "This way of paying comes later and stays off until then.",
    "bank_account_missing": "Customers cannot pay by transfer yet — add the shop's bank account.",
    "translations_missing": "Some languages have no text yet — customers read English instead.",
    "fee_percent_high": "This card fee is above 5% — please check it again.",
    "pickup_location_missing": "No shop offers pickup — customers cannot choose to pay at the shop.",
    "pickup_location_unverified": "Could not check the pickup shops right now."
  },
  "bank": {
    "title": "Bank transfer (銀行振込)",
    "desc": "The main way to pay on the website for now. Staff confirm the money arrived.",
    "account": "The shop's bank account",
    "bank_name": "Bank name",
    "bank_code": "Bank code (4 digits)",
    "bank_name_en": "Bank name (English)",
    "branch_name": "Branch name",
    "branch_code": "Branch code (3 digits)",
    "branch_name_en": "Branch name (English)",
    "account_type": "Account type",
    "futsu": "Ordinary (普通)",
    "toza": "Current (当座)",
    "account_number": "Account number (7 digits)",
    "account_name": "Account holder (カナ)",
    "account_name_help": "Exactly as the bank writes it, in katakana.",
    "problem_required": "{{field}} is needed.",
    "problem_format": "{{field}} does not look right.",
    "fix_account": "Check the bank account boxes marked in red.",
    "instructions": "What the customer reads",
    "instructions_field": "How to pay",
    "instructions_hint": "Shown on the order page, the e-mail and the tracking page. English and Japanese are needed; the others fall back to English.",
    "missing_locale": "No {{language}} yet (English is used)",
    "text_en_ja": "Write the text in English and Japanese.",
    "days": "Days to pay",
    "days_help": "The cards stay held for the customer until then.",
    "days_hint": "1 to 14 days (usually 3).",
    "days_range": "Choose 1 to 14 days.",
    "singles": "Single cards can be paid by bank transfer",
    "singles_on": "On: customers can pay any card by bank transfer (the card is kept for them until the money arrives).",
    "singles_off": "Off: when the cart has a single card, bank transfer is not offered. Sealed products can still be paid this way.",
    "singles_help": "A single card is held for the customer while you wait for the money. Turn this off if you do not want one-of-a-kind cards held that long.",
    "singles_none_left": "Customers who want a single card sent to them will have no way to pay online — only picking it up at the shop will work. Turn on another way to pay for sent orders first if you still want to sell single cards by post."
  },
  "locale": {
    "en": "English",
    "ja": "Japanese",
    "th": "Thai",
    "zh-Hant": "Chinese (Traditional)",
    "zh-Hans": "Chinese (Simplified)"
  },
  "simple": {
    "cash": {
      "title": "Cash (現金)",
      "desc": "At the shop counter."
    },
    "pay_in_store": {
      "title": "Pay at pickup (店頭払い)",
      "desc": "The customer orders on the website and pays when picking up."
    },
    "pickup_days": "Days the order waits for pickup",
    "pickup_days_help": "After this the order is cancelled and the cards go back on sale.",
    "days_range": "Choose 1 to 30 days."
  },
  "store_credit": {
    "title": "Store credit",
    "desc": "Credit the shop gave a customer (returns, buy-ins).",
    "months": "Credit lasts",
    "months_help": "Credit that lasts longer than 6 months counts as a prepaid payment under 資金決済法 (reports and a deposit).",
    "month_option_one": "{{count}} month",
    "month_option_other": "{{count}} months",
    "max": "Longest allowed",
    "law": "資金決済法 — the shop keeps it at 6 months or less."
  },
  "edc": {
    "title": "Card terminals (EDC)",
    "intro": "The card machines at the counter. The fee of every card sale is worked out from these values.",
    "add": "Add a terminal (端末を追加)",
    "add_title": "Add a card terminal",
    "edit": "Change fees",
    "edit_title": "Card terminal {{name}}",
    "dialog_desc": "Fees as in your terminal contract.",
    "card_desc": "Card terminal at the counter",
    "none": "No card terminal yet.",
    "needs_review": "Check the example fees",
    "name": "Terminal name",
    "name_placeholder": "Terminal 1",
    "name_required": "Give the terminal a name.",
    "company": "Card company",
    "company_help": "The company of the terminal contract (for you — not shown to customers).",
    "fee_percent": "Fee (%)",
    "fee_percent_help": "The usual % of the contract. A brand can have its own % below.",
    "fee_fixed": "Fixed fee per payment",
    "fee_fixed_help": "Some contracts add a fixed yen amount to each payment.",
    "percent_format": "Write the % like 3.24.",
    "percent_max": "At most 10%.",
    "percent_high": "Above 5% — please check it again.",
    "fix_percent": "Check the % boxes marked in red.",
    "brands": "Fee per card brand",
    "brands_hint": "Empty = the terminal's usual %. Untick a brand the terminal does not take.",
    "brand_percent": "{{brand}} fee in %",
    "more_brands": "More brands (UnionPay, iD, QUICPay, IC cards…)",
    "fewer_brands": "Fewer brands",
    "not_accepted": "Not taken",
    "bearer": "Who carries the fee",
    "bearer_help": "The shop, the consignors (their share of the sale), or the customer.",
    "surcharge_warning": "Adding card fees to the customer's bill may break Japanese card-network rules and your terminal contract. Ask your card company first.",
    "surcharge_ack": "I have checked the surcharge rules",
    "ack_required": "Tick \"I have checked the surcharge rules\" first.",
    "min_amount": "Smallest amount (optional)",
    "max_amount": "Largest amount (optional)",
    "preview_after_percent": "The example shows once the % is written.",
    "save": "Save",
    "confirm_add": "Add this terminal?",
    "confirm_edit": "Save the new fees?",
    "confirm_consequence": "Every card payment on this terminal from now on uses these fees. The change is kept in the history.",
    "summary_default": "Usual fee: {{percent}}%"
  },
  "bearer": {
    "shop": "The shop",
    "shop_desc": "The shop pays the whole fee.",
    "consignor_pro_rata": "Consignors, by share",
    "consignor_pro_rata_desc": "Each consignor pays the part of the fee of their cards.",
    "customer_surcharge": "The customer",
    "customer_surcharge_desc": "Added to the customer's bill — check the rules first."
  },
  "bearer_short": {
    "shop": "the shop pays",
    "consignor_pro_rata": "consignors pay their share",
    "customer_surcharge": "the customer pays"
  },
  "brand": {
    "VISA": "Visa",
    "MASTER": "Mastercard",
    "JCB": "JCB",
    "AMEX": "American Express",
    "DINERS": "Diners Club",
    "DISCOVER": "Discover",
    "UNIONPAY": "UnionPay (銀聯)",
    "ID": "iD",
    "QUICPAY": "QUICPay",
    "SUICA_TRANSIT": "IC card (Suica etc.)",
    "PAYPAY_VIA_EDC": "PayPay (terminal)",
    "OTHER": "Other"
  },
  "fee_preview": {
    "title": "Example",
    "updating": "Updating the example",
    "amount": "Amount",
    "brand": "Card",
    "fee": "fee",
    "net": "The shop receives"
  },
  "stripe": {
    "title": "Online card payments",
    "will_add": "Ways the card connection will add",
    "method": {
      "card": "Cards",
      "apple_pay": "Apple Pay",
      "google_pay": "Google Pay",
      "konbini": "Convenience store (コンビニ)",
      "paypay": "PayPay"
    }
  },
  "reconcile": {
    "title": "Card terminal statements",
    "intro": "Upload the statement of a card terminal for a month. The system matches every line with the card payments it recorded and shows what differs.",
    "result_intro": "What matches, what differs, and what to do.",
    "no_terminal": "No card terminal yet",
    "no_terminal_body": "Add the terminal in Ways to pay first.",
    "terminal": "Terminal",
    "month": "Month",
    "choose_file": "Choose the statement (CSV)",
    "file_required": "Choose the statement file.",
    "check": "Check the statement",
    "reading": "Reading the statement…",
    "choose_columns": "The columns of this file were not found — choose them below once; the terminal remembers them.",
    "columns": "Which column is what",
    "columns_hint": "Date and amount are needed; the more you choose, the better the match.",
    "columns_required": "Choose the date and the amount columns.",
    "not_in_file": "Not in the file",
    "field": {
      "date": "Date",
      "amount": "Amount",
      "approvalCode": "Approval number (承認番号)",
      "last4": "Card last 4 digits",
      "brand": "Card brand",
      "fee": "Fee",
      "time": "Time",
      "kind": "Sale or cancel"
    },
    "duplicate": "This statement was checked already.",
    "open_existing": "Open it",
    "history": "Statements checked",
    "batch_status": {
      "uploaded": "Received",
      "parsing": "Reading",
      "open": "Something to check",
      "reconciled": "All matched",
      "failed": "Could not read"
    },
    "export": "Download (CSV)",
    "another": "Check another statement",
    "statement_gross": "Sales on the statement",
    "expected_gross": "Card sales in the system",
    "statement_fee": "Fees on the statement",
    "expected_fee": "Fees the system expected",
    "fee_difference": "Difference:",
    "groups": "Lines",
    "group": {
      "matched": "Matched",
      "variance": "Fee differs",
      "unmatched": "Not in the system",
      "missing_in_statement": "Not on the statement",
      "ignored": "Checked"
    },
    "group_help": {
      "matched": "The statement line and the recorded payment agree.",
      "variance": "The payment was found, but the provider charged another fee.",
      "unmatched": "The terminal has it, the system does not — match it by hand or mark it checked.",
      "missing_in_statement": "Recorded in the system but not on the statement — check with the provider.",
      "ignored": "Lines marked as checked, with the note why."
    },
    "group_empty": "Nothing here.",
    "line": "Line",
    "date": "Date",
    "amount": "Amount",
    "card": "Card",
    "fee": "Fee",
    "expected": "Expected fee",
    "difference": "Difference",
    "order": "Order",
    "what": "State",
    "match": "Match",
    "match_title": "Match line {{line}}",
    "match_desc": "Choose the card payment this line belongs to. Same amount first.",
    "no_candidates": "No card payment of this terminal in the period.",
    "matched": "Matched.",
    "ignore": "Mark checked",
    "ignore_title": "Line {{line}} is fine",
    "note": "Why",
    "note_hint": "For example: cancelled on the terminal the same day.",
    "ignored": "Marked as checked.",
    "fees_title": "Fees per card brand",
    "fees_intro": "What the system expected from the saved % (worked out by the system).",
    "brand": "Brand",
    "count": "Payments",
    "fee_suggest_one": "{{brand}}: the provider charged {{percent}}% on {{count}} payment.",
    "fee_suggest_other": "{{brand}}: the provider charged {{percent}}% on {{count}} payments.",
    "fee_use": "Use {{percent}}% from now on",
    "fee_confirm_title": "Change the fee?",
    "fee_confirm": "{{brand}} payments on this terminal use {{percent}}% from now on. Payments already recorded keep their fee.",
    "fee_confirm_button": "Change the fee",
    "fee_set": "{{brand}} now uses {{percent}}%."
  },
  "refunds": {
    "title": "Refunds",
    "intro": "Every refund of every order: how much, how it goes back and where it stands.",
    "order": "Order",
    "amount": "Amount",
    "method": "How",
    "reason": "Why",
    "status": "State",
    "who": "Asked by",
    "approved_by": "approved by {{name}}",
    "date": "Date",
    "invoice": "Refund receipt",
    "invoice_open": "Documents of the order",
    "view_open": "Still to do",
    "view_done": "Done",
    "empty": "No refunds."
  },
  "refund_method": {
    "original": "Same way as paid",
    "cash": "Cash",
    "bank_transfer": "Bank transfer",
    "store_credit": "Store credit",
    "edc_manual": "Card terminal"
  },
  "refund_reason": {
    "order_cancelled": "Order cancelled",
    "return": "Return",
    "overpayment": "Paid too much",
    "price_adjustment": "Price correction",
    "goodwill": "Goodwill",
    "tax_free_refund": "Tax-free pay-back",
    "other": "Other"
  },
  "refund_status": {
    "requested": "Asked",
    "pending_approval": "Waiting for approval",
    "approved": "Approved",
    "processing": "In progress",
    "completed": "Done",
    "failed": "Failed",
    "rejected": "Rejected"
  },
  "refund_next": {
    "waiting_approval": "Another person must approve",
    "hand_cash": "Hand the cash back",
    "enter_terminal_reference": "Type the terminal's cancel number",
    "waiting_destination": "Waiting for the customer's bank details",
    "transfer_money": "Send the transfer",
    "failed": "Try again"
  }
}
